import React from "react";
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const PrecautionsDialog = ({
  open,
  onClose,
  onSelect,
  selectedPrecautions,
  precautions,
}) => {
  const handleSelect = (precaution) => {
    if (selectedPrecautions.includes(precaution)) {
      onSelect(selectedPrecautions.filter((p) => p !== precaution));
    } else {
      onSelect([...selectedPrecautions, precaution]);
    }
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>Select Precautions</DialogTitle>
      <List>
        {precautions.map((precaution) => (
          <ListItem
            button
            key={precaution}
            onClick={() => handleSelect(precaution)}
            selected={selectedPrecautions.includes(precaution)}
          >
            <ListItemText primary={precaution} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};

export default PrecautionsDialog;
